export default function ApproachSection() {
  return (
    <section className="relative w-full py-24 md:py-32 px-8 md:px-16 lg:px-24 bg-background-50" aria-labelledby="approach-title">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24">
          <div className="lg:w-[40%]">
            <div className="inline-block border border-foreground-300/60 rounded-full px-4 py-1.5 mb-8">
              <span className="font-label text-xs text-foreground-500 tracking-wide">Our Approach</span>
            </div>

            <h2 id="approach-title" className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight tracking-tight mb-4">
              Clean Architecture
            </h2>
            <p className="font-heading text-4xl md:text-5xl lg:text-6xl font-light text-foreground-600 leading-tight tracking-tight mb-16">
              &amp; User-Centered Design
            </p>

            <p className="text-base md:text-lg text-foreground-700 leading-relaxed max-w-lg">
              We follow modern software engineering practices that prioritize separation of concerns, testability, and long-term maintainability. Our architecture decisions are guided by a deep understanding of the iOS platform and its evolving ecosystem, ensuring that every system we build remains adaptable to future requirements while delivering exceptional performance today.
            </p>
          </div>

          <div className="lg:w-[55%] relative">
            <div className="flex gap-6">
              <div className="w-[45%] mt-0">
                <div className="rounded-2xl overflow-hidden aspect-square shadow-[0_8px_32px_rgba(0,0,0,0.06)]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20geometric%20composition%20in%20muted%20sage%20green%20and%20warm%20beige%20tones%2C%20soft%20rounded%20shapes%20with%20gentle%20gradients%2C%20no%20objects%20no%20people%2C%20fine%20art%20quality%2C%20architectural%20abstract%2C%20clean%20aesthetic%20with%20delicate%20color%20blocking&width=600&height=600&seq=approach-card-01-bruny&orientation=squarish"
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="w-[55%] mt-16">
                <div className="rounded-2xl overflow-hidden aspect-[3/4] shadow-[0_8px_32px_rgba(0,0,0,0.06)]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20texture%20in%20warm%20coral%20and%20soft%20charcoal%20tones%2C%20layered%20organic%20shapes%20with%20subtle%20contrast%2C%20minimalist%20fine%20art%20composition%2C%20no%20objects%20no%20people%2C%20soft%20gradients%20and%20delicate%20color%20transitions%2C%20contemporary%20aesthetic&width=700&height=933&seq=approach-card-02-bruny&orientation=portrait"
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>

            <div className="absolute top-0 right-0">
              <div className="text-right">
                <p className="font-heading text-4xl md:text-5xl font-bold text-accent-600 leading-none">100%</p>
                <p className="text-xs text-foreground-500 mt-2 leading-tight">iOS Platform<br />Focus</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}